module.exports = __webpack_public_path__ + "img/shenping.bea3bb82.jpg";